module.exports = __webpack_public_path__ + "static/media/Finnovex-EA-2025.2c9e3016.png";